<!-- 弹窗组件 -->
<template>
    <div>
        <div class="content1" v-if="popValue && popData.content.styleValue == 1"
            :style="`
                padding: ${popData.content.marginData.top}px ${popData.content.marginData.left}px;
                border-radius: ${popData.content.marginData.topRadius}px ${popData.content.marginData.topRadius}px ${popData.content.marginData.bottomRadius}px ${popData.content.marginData.bottomRadius}px;
                background-color: ${popData.content.bg_color}; top: calc(${operateData.top_cha}px + 270px);
            `"
        >
            <div>
                <div class="mt-12 mb-12 ta-c" :style="`font-size: ${popData.content.title_size}px;color: ${popData.content.title_color};`">
                    {{ popData.content.title }}
                </div>
                <div :style="`text-align: ${popData.content.text_position};font-size: ${popData.content.text_size}px;color: ${popData.content.text_color};`">
                    {{ popData.content.text }}
                </div>
                <div class="btn-div" v-if="popData.content.btnValue == 2" @click="closePop"
                    :style="`
                        margin: 24px ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;
                        background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                    `"
                >
                    {{ popData.content.btn_text }}
                </div>
                <div class="ai-c" v-if="popData.content.btnValue == 3" :style="`margin: 24px ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;`">
                    <div class="btn-div w100" @click="closePop"
                        :style="`
                            background-color: ${popData.content.btn_bg_color2}; border: 1px solid ${popData.content.btn_border_color2}; border-radius: ${popData.content.btnRadius}px;
                        `"
                    >
                        {{ popData.content.btn_text2 }}
                    </div>
                    <div class="btn-div w100 pt-6 pb-6" @click="closePop"
                        :style="`margin-left: 12px;
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                        `"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
            </div>
        </div>
        <div class="content2" v-if="popValue && popData.content.styleValue == 2"
            :style="`
                padding: ${popData.content.marginData.top}px ${popData.content.marginData.left}px;background-color: ${popData.content.bg_color};
                border-radius: ${popData.content.marginData.topRadius}px ${popData.content.marginData.topRadius}px ${popData.content.marginData.bottomRadius}px ${popData.content.marginData.bottomRadius}px;
            `"
        >
            <div class="countdown-div" v-if=" popData.content.picview && popData.content.cancelValue == 2 && popData.content.countdown "
                :style="`
                    background-color: ${ popData.content.countdown_bg_color };color: ${ popData.content.countdown_text_color }; opacity: ${ popData.content.countdown_opacity * 0.01 };
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <img class="img1" v-if=" popData.content.picview && popData.content.cancelValue == 1 && popData.content.cancelPositionValue == 1 "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <img class="img2" v-if=" popData.content.picview && popData.content.cancelValue == 1 && popData.content.cancelPositionValue == 2 "
                src="@/assets/pop_close.png"
                @click="closePop"
            />
            <img class="img3" v-if="popData.content.picview" :src="popData.content.picview"
                :style="`border-radius: ${popData.content.marginData.topRadius}px ${popData.content.marginData.topRadius}px ${popData.content.marginData.bottomRadius}px ${popData.content.marginData.bottomRadius}px;`"
            />
            <div v-else>请上传图片</div>
            <div class="position-absolute" v-if="popData.content.picview"
                :style="`bottom: calc(${popData.content.marginData.top}px + 12px); left: ${popData.content.btnMargin}px; right: ${popData.content.btnMargin}px;`"
            >
                <div class="btn-div" v-if="popData.content.btnValue == 2"
                    :style="`
                        margin: 0 ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;
                        background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                    `"
                    @click="closePop"
                >
                    {{ popData.content.btn_text }}
                </div>
                <div class="ai-c" v-if="popData.content.btnValue == 3"
                    :style="`margin: 0 ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;`"
                >
                    <div class="w100 btn-div"
                        :style="`
                            background-color: ${popData.content.btn_bg_color2}; border: 1px solid ${popData.content.btn_border_color2}; border-radius: ${popData.content.btnRadius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text2 }}
                    </div>
                    <div class="w100 btn-div"
                        :style="`margin-left: 12px;
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
            </div>
        </div>
        <div class="content3" v-if="popValue && popData.content.styleValue == 3"
            :style="`
                padding: ${popData.content.marginData.top}px ${popData.content.marginData.left}px; background-color: ${popData.content.bg_color};
                border-radius: ${popData.content.marginData.topRadius}px ${popData.content.marginData.topRadius}px ${popData.content.marginData.bottomRadius}px ${popData.content.marginData.bottomRadius}px;
            `"
        >
            <div class="countdown-div3" v-if="popData.content.picview && popData.content.countdown"
                :style="`
                    background-color: ${ popData.content.countdown_bg_color }; color: ${ popData.content.countdown_text_color }; opacity: ${ popData.content.countdown_opacity * 0.01 };
                `"
            >
                {{ popData.content.countdown }}s | 跳过
            </div>
            <img class="w100" v-if="popData.content.picview" :src="popData.content.picview"
                :style="`border-radius: ${popData.content.marginData.topRadius}px ${popData.content.marginData.topRadius}px ${popData.content.marginData.bottomRadius}px ${popData.content.marginData.bottomRadius}px;`"
            />
            <div v-else>请上传图片</div>
            <div class="position-absolute" v-if="popData.content.picview"
                :style="`
                    bottom: calc(${popData.content.marginData.top}px + 12px); left: ${popData.content.btnMargin}px; right: ${popData.content.btnMargin}px;
                `"
            >
                <div class="btn-div" v-if="popData.content.btnValue == 2"
                    :style="`
                        margin: 0 ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;
                        background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                    `"
                    @click="closePop"
                >
                    {{ popData.content.btn_text }}
                </div>
                <div class="ai-c" v-if="popData.content.btnValue == 3" :style="`margin: 0 ${popData.content.btnMargin}px 0 ${popData.content.btnMargin}px;`">
                    <div class="btn-div w100"
                        :style="`
                            background-color: ${popData.content.btn_bg_color2}; border: 1px solid ${popData.content.btn_border_color2}; border-radius: ${popData.content.btnRadius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text2 }}
                    </div>
                    <div class="btn-div w100"
                        :style="`margin-left: 12px;
                            background-color: ${popData.content.btn_bg_color}; border: 1px solid ${popData.content.btn_border_color}; border-radius: ${popData.content.btnRadius}px;
                        `"
                        @click="closePop"
                    >
                        {{ popData.content.btn_text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        popData: {
            type: Object,
            default: {},
        },
        operateData: {
            type: Object,
            default: {},
        },
        popValue: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        closePop() {
            this.$emit('update:popValue', false);
        },
    },
};
</script>

<style scoped>
.content1 {
    position: absolute;
    left: 20px;
    right: 20px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    z-index: 1000;
}
.btn-div {
    padding: 6px 0;
    color: #fff;
    font-size: 16px;
    text-align: center;
}
.ai-c {
    display: flex;
    align-items: center;
}
.w100 {
    width: 100%;
}
.content2 {
    position: absolute;
    top: 200px;
    left: 37.5px;
    right: 37.5px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    z-index: 1000;
}
.countdown-div {
    padding: 0 6px;
    border-radius: 10px;
    position: absolute;
    top: -188px;
    left: -24px;
}
.img1 {
    position: absolute;
    top: -40px;
    right: 0;
    width: 20px;
    height: 20px;
}
.img2 {
    position: absolute;
    bottom: -60px;
    left: calc(50% - 16px);
    width: 32px;
    height: 32px;
}
.img3 {
    width: 100%;
    height: 300px;
    display: block;
}
.position-absolute {
    position: absolute;
}
.content3 {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    z-index: 1000;
}
.countdown-div3 {
    padding: 0 6px;
    position: absolute;
    top: 12px;
    left: 12px;
    border-radius: 12px;
}
.w100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.pt-6 {
    padding-top: 6px;
} 
.pb-6 {
    padding-bottom: 6px;
}
</style>